import { Directive, HostListener, computed, inject } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { Store } from "@ngrx/store";
import { RegionOverlay } from "src/app/core/interfaces/overlay";
import { closeLaunchpad, closeNews, closeWebinars, openLaunchpad } from "src/app/ngrx/actions/overlay.actions";
import { selectRegionOverlay } from "src/app/ngrx/selectors/overlay.selectors";

const overlayIconMap: Record<RegionOverlay, string> = {
  launchpad: "gpi-filled-circled-arrow-left",
  news: "gpi-filled-home-alt",
  webinars: "gpi-filled-home-alt"
};

const notDefinedIcon = "gpi-filled-home-alt";

const overlayLabelMap: Record<RegionOverlay, string> = {
  launchpad: "OVERLAY_CONTROL.launchpad",
  news: "OVERLAY_CONTROL.news",
  webinars: "OVERLAY_CONTROL.webinars"
};

const notDefinedLabel = "OVERLAY_CONTROL.notDefined";

@Directive({
  selector: "button[tpmOverlayControl], tpm-button[tpmOverlayControl], tpm-icon[tpmOverlayControl]",
  host: {
    class: "overlay-control-base"
  },
  standalone: true,
  exportAs: "tpmOverlayControl"
})
export class OverlayControlBaseDirective {
  private readonly store = inject(Store);
  private readonly overlay = toSignal<RegionOverlay>(this.store.select(selectRegionOverlay));

  private readonly overlayToAction: Record<RegionOverlay, () => void> = {
    launchpad: () => {
      this.store.dispatch(closeLaunchpad());
    },
    news: () => {
      this.store.dispatch(closeNews());
    },
    webinars: () => {
      this.store.dispatch(closeWebinars());
    }
  };

  readonly icon = computed<string>(() => overlayIconMap[this.overlay()] ?? notDefinedIcon);
  readonly label = computed<string>(() => overlayLabelMap[this.overlay()] ?? notDefinedLabel);

  @HostListener("click")
  onClick(): void {
    this.updateOverlay();
  }

  updateOverlay(): void {
    if (this.overlay() && this.overlayToAction[this.overlay()]) {
      this.overlayToAction[this.overlay()]();
    } else {
      this.store.dispatch(closeNews());
      this.store.dispatch(openLaunchpad());
    }
  }
}
